module.exports = __webpack_public_path__ + "static/media/8.e873a37c.png";